import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IShoppingListCategory } from '@/interfaces/ShoppingList';
import { IIngredientCategory } from '@/interfaces/Ingredient';
import { Tab } from '@/interfaces/Tab';
import { ICard, CardSize } from '@/interfaces/Card';
import { MxrType } from '@/interfaces/MxrConfig';
import {
    GET_CURRENT_CARD,
    GET_MXR_TYPE,
    GET_SIZE,
    GET_SELECTED_TAB,
    GET_SHOPPING_LIST
} from '@/store/types';

@Component({
})
export default class TabContent extends Vue {
    @Getter(GET_SELECTED_TAB) selectedTab!: Tab;

    @Getter(GET_CURRENT_CARD) getCurrentCard!: ICard;

    @Getter(GET_SHOPPING_LIST) getShoppingList!: IShoppingListCategory[];

    @Getter(GET_SIZE) size!: CardSize;

    @Getter(GET_MXR_TYPE) mxrType!: MxrType;

    get directions(): string {
        return (this.getCurrentCard && this.getCurrentCard.directions) ? this.getCurrentCard.directions : '';
    }

    get ingredients(): IIngredientCategory[] {
        return (this.getCurrentCard && this.getCurrentCard.ingredientCategories) ? this.getCurrentCard.ingredientCategories : [] as IIngredientCategory[];
    }
}
